<section class="container-fluid position-relative top-119 py-10 backgroundColor shark lighten-1">
  <div class="container pb-5">
    <div class="pt-16 text-center textColor harvest-gold base text-shadow">
      <h1>Consola de Administração</h1>
    </div>
    <div class="row d-flex justify-content-around">
      <div class="col-10 col-sm-10 col-md-3 col-lg-3 card backgroundColor mine-shaft base mt-5 py-3 card-border card-expand shadow-card">
        <fa-icon [icon]="faFolderPlus" class="textColor star-dust base mx-auto my-3 fa-5x"></fa-icon>
        <a href="/admin/marcas" class="mx-auto my-3">
          <button type="button" class="btn btn-grad mt-5 py-3 px-4">
            Inserção de Marcas
          </button>
        </a>
      </div>
      <div class="col-10 col-sm-10 col-md-3 col-lg-3 card backgroundColor mine-shaft base mt-5 py-3 card-border card-expand shadow-card">
        <fa-icon [icon]="faCog" class="textColor star-dust base fa-5x mx-auto my-3"></fa-icon>
        <a href="/admin/gestaoMarcas" class="mx-auto my-3">
          <button type="button" class="btn btn-grad mt-5 py-3 px-4">
            Gestão de Marcas
          </button>
        </a>
      </div>
    </div>
  </div>
</section>
<div class="backgroundColor mine-shaft base">
  <section class="container-fluid backgroundColor mine-shaft base position-relative top-119 py-5">
    <div class="container pb-10">
      <div class="row d-flex justify-content-around">
        <div class="col-10 col-sm-10 col-md-3 col-lg-3 card backgroundColor mine-shaft lighten-1 mt-5 py-3 card-border card-expand shadow-card">
          <fa-icon [icon]="faCartPlus" class="textColor mine-shaft base fa-5x mx-auto my-3"></fa-icon>
          <a href="/admin/produtos" class="mx-auto my-3">
            <button type="button" class="btn btn-grad mt-5 py-3 px-4">
              Inserção de Produtos
            </button>
          </a>
        </div>
        <div class="col-10 col-sm-10 col-md-3 col-lg-3 card backgroundColor mine-shaft lighten-1 mt-5 py-3 card-border card-expand shadow-card">
          <fa-icon [icon]="faCogs" class="fad fa-cogs textColor mine-shaft base fa-5x mx-auto my-3"></fa-icon>
          <a href="/admin/gestao" class="mx-auto my-3">
            <button type="button" class="btn btn-grad mt-5 py-3 px-4">
              Gestão de Produtos
            </button>
          </a>
        </div>
        <div class="col-10 col-sm-10 col-md-3 col-lg-3 card backgroundColor mine-shaft lighten-1 mt-5 py-3 card-border card-expand shadow-card">
          <fa-icon [icon]="faHighlighter" class="fad fa-highlighter textColor mine-shaft base fa-5x mx-auto my-3"></fa-icon>
          <a href="#" class="mx-auto my-3">
            <a type="button" class="btn btn-grad mt-5 py-3 px-4" href="/admin/destaques">
              Gestão de Destaques
            </a>
          </a>
        </div>
      </div>
    </div>
  </section>
</div>
<section class="container-fluid position-relative top-119 py-10 backgroundColor shark lighten-1">
  <div class="container pb-5">
    <div class="row d-flex justify-content-around">
      <div class="col-10 col-sm-10 col-md-3 col-lg-3 card backgroundColor mine-shaft base mt-5 py-3 card-border card-expand shadow-card">
        <fa-icon [icon]="faNewspaper" class="fad fa-newspaper textColor star-dust base fa-5x mx-auto my-3"></fa-icon>
        <a href="/admin/noticias" class="mx-auto my-3">
          <button type="button" class="btn btn-grad mt-5 py-3 px-4">
            Inserção de Notícias
          </button>
        </a>
      </div>
      <div class="col-10 col-sm-10 col-md-3 col-lg-3 card backgroundColor mine-shaft base mt-5 py-3 card-border card-expand shadow-card">
        <fa-icon [icon]="faImages" class="fad fa-images textColor star-dust base fa-5x mx-auto my-3"></fa-icon>
        <a href="/admin/carousel" class="mx-auto my-3">
          <button type="button" class="btn btn-grad mt-5 py-3 px-4">
            Gestão do Slide Show
          </button>
        </a>
      </div>
      <div class="col-10 col-sm-10 col-md-3 col-lg-3 card backgroundColor mine-shaft base mt-5 py-3 card-border card-expand shadow-card">
        <fa-icon [icon]="faUserCog" class="fad fa-users-cog textColor star-dust base fa-5x mx-auto my-3"></fa-icon>
        <a href="/admin/funcionarios" class="mx-auto my-3">
          <button type="button" class="btn btn-grad mt-5 py-3 px-4">
            Gestão de Funcionários
          </button>
        </a>
      </div>
    </div>
  </div>
</section>